import * as React from "react";
import {CSSProperties, PropsWithChildren, useContext, useEffect, useImperativeHandle, useState} from "react";
import {Backdrop, Box, CircularProgress, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

interface LoadingProps {
    fullscreen?:boolean,
    show?:boolean,
    title?:string,
    style?:CSSProperties
}

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        position:"fixed",
        flexDirection:"column"
    }
}));

export type LoadingExposed = {
    setShow(status:boolean):void;
    show:boolean;
}

export type LoadingContextType = {
    loading?: boolean,
    setLoading?: (loading: boolean) => void
}

export const LoadingContext = React.createContext<LoadingContextType>({});
export const useLoadingContext = () => useContext(LoadingContext);

export function LoadingContextProvider(props: PropsWithChildren<any>) {
    const [loading, setLoading] = useState(false);
    const {Provider} = LoadingContext;

    return <Provider value={{loading, setLoading}}>
        {props.children}
    </Provider>
}


export const Loading = React.forwardRef<LoadingExposed, PropsWithChildren<LoadingProps>>(({children, title, fullscreen=false, show:pshow=false, style}, ref) => {
    const classes = useStyles();
    const [show, setLoadingShow] = useState(pshow??false);
    const {loading} = useLoadingContext();

    useImperativeHandle(ref, ()=>({
        setShow,
        show
    }));

    const setShow = (status: boolean) => {
        if (status !== show) setLoadingShow(status);
    }

    useEffect(()=>{
        setShow((pshow || loading) ?? false);
        // eslint-disable-next-line
    }, [pshow, loading]);

    return (
        <Backdrop className={classes.backdrop} open={show??false} style={{position:fullscreen?"fixed":"absolute", ...style}}>
            {children ?? (
                <>
                    <Box>
                        <CircularProgress color="inherit" />
                    </Box>
                    <Box>
                        {title && <Typography variant={"h4"} color={"inherit"}>{title}</Typography>}
                    </Box>
                </>
            )}
        </Backdrop>
    );
});
